import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

const columns = [
  {
    title: "浏览",
    links: [
      { label: "首页", to: "/" },
      { label: "全部筛选", to: "/list" },
      { label: "搜索动漫", to: "/search" },
      { label: "我的收藏", to: "/favorites" },
    ],
  },
  {
    title: "热门分类",
    links: categories.slice(0, 4).map((cat) => ({ label: `${cat.name}动漫`, to: `/category/${cat.id}` })),
  },
  {
    title: "更多分类",
    links: categories.slice(4).map((cat) => ({ label: `${cat.name}动漫`, to: `/category/${cat.id}` })),
  },
];

export default function SiteFooter() {
  return (
    <footer className="mt-12 bg-primary-950 text-background-100">
      <div className="px-4 md:px-6 py-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 rounded-lg bg-accent-500 text-primary-950 flex items-center justify-center">
                <i className="ri-movie-2-fill text-lg" />
              </span>
              <span className="font-heading text-base font-bold text-background-50 whitespace-nowrap">
                动漫免费在观看
              </span>
            </div>
            <p className="mt-3 text-[12px] leading-relaxed text-background-300">
              一个为动漫爱好者打造的高清动漫浏览门户。覆盖多种题材，支持分类、筛选与搜索，让每一次打开都有新的发现。
            </p>
            <p className="mt-3 text-[11px] text-background-400">
              本站集数为演示界面，不提供真实视频播放与下载。
            </p>
          </div>
          {columns.map((column) => (
            <div key={column.title}>
              <p className="text-[11px] font-semibold tracking-widest text-accent-400">{column.title}</p>
              <ul className="mt-3 space-y-2">
                {column.links.map((link) => (
                  <li key={link.to + link.label}>
                    <Link
                      to={link.to}
                      className="text-[12px] text-background-200 hover:text-accent-400 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-8 pt-5 border-t border-primary-800 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2 text-[11px] text-background-400">
          <p>© 2026 动漫免费在观看 · 本站内容仅供演示与学习交流使用</p>
          <div className="flex items-center gap-4">
            <Link to="/about" className="hover:text-accent-400 transition-colors cursor-pointer">
              关于我们
            </Link>
            <Link to="/about" className="hover:text-accent-400 transition-colors cursor-pointer">
              免责声明
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}